import { Button, Divider, Modal, Radio, Space, Image } from 'antd';
import { withTranslation } from 'react-i18next';
import styled from 'styled-components';


import Text from 'components/Text';
import { useEffect, useState } from 'react';
import Title from 'components/Title';
import { connect } from 'react-redux';

const StyledButtonLink = styled(Button)`
  &:hover {
    color: #13a9c6 !important;
  }
`;

const StyledModal = styled(Modal)`
  button.ant-btn-primary {
    background: ${ props => props.theme.buttonColor} !important;
  }

  .ant-btn-link {
    color: ${props => props.theme.linksColor} !important;
  }
`;

/**
 * OptionsModal
 * @param {*} props 
 * @returns 
 */
const OptionsModal = (props) => {
  const [selectableOptions, setSelectableOptions] = useState([]);
  const [errors, setErrors] = useState(false);

  useEffect(() => {
    setEnv()
  }, []) // eslint-disable-line

  const setEnv = () => {
    const entries = [];
    _getOptions(props.options).forEach((poption, i) => {
      // Prefill required options
      let isRequired = false;

      poption.selectableOptions.forEach((sopt) => {
        if (poption.is_required || poption.is_required_in_app) {
          isRequired = true;
        }
      })

      entries.push({
        selectableOptionName: poption.name,
        selectableOptions: poption.selectableOptions,
        selectedOption: null,
        isRequired,
        tempId: i
      })
    })
    setSelectableOptions(entries);
  }

  const _getOptions = (options) => { 
    if (Array.isArray(options)) {
      const tableData = options.map((option) => {
        const entries = _getSelectableOptionsForSupport(option);
        return {
          ...option, 
          selectableOptions: entries
        }
      })
      return tableData;
    } else {
      const tableData = [];
      for (const key in options) {
        if (options.hasOwnProperty(key)) {
          const entries = _getSelectableOptionsForSupport(options[key]);
          if (entries.length > 0) {
            options[key].selectableOptions = entries;
            tableData.push(options[key]);
          }
        }
      }
      return tableData;
    }
    
  }

  const _getSelectableOptionsForSupport = (option) => {
    const selectableOptions = option.selectableOptions;
    return  option.values.filter((val) => selectableOptions.includes(val.id)).map((val) => val)
  }

  const getSelectedOptionForCategory = (category) => {
    return category.selectedOption ? category.selectedOption.id : null;
  }

  const handleOnChooseOption = (category) => (option) => {
    const newEntries = [...selectableOptions];
    newEntries.forEach((cat, index) => {
      if (category.tempId === cat.tempId) {
        newEntries[index].selectedOption = option;
      }
    })
    setSelectableOptions(newEntries)
  }

  const handleOnSubmitOption = async () => {
    let error = false;
    selectableOptions.forEach((category) => {
      if (category.isRequired && category.selectedOption === null) {
        error = true;
      }
    })

    if (error) {
      setErrors(true);
    } else {
      // Send order
      props.onOk();
      props.handleOnOptionsSelected(selectableOptions)
    }
  }

  if (!props.options) {
    return null;
  }

  return (
    <StyledModal
      visible={props.visible}
      onOk={props.onOk}
      onCancel={props.onCancel}
      footer={null}
      // closable={false}
      maskClosable={false}
      style={{ top: 10 }}
      theme={props.ui.theme}
    >
      <Title size={18}>Options</Title>
      <Divider />

      {
        errors && (
          <Text color="red" size={12} style={{ marginBottom: 10 }}>Les options marquées d'un * sont obligatoires</Text>
        )
      }

      <div style={{ marginBottom: 20 }}>
        {
          selectableOptions.map((category) => (
            <div style={{ marginBottom: 20 }}>
              <Space>
                <Text size={14}>{`${category.selectableOptionName}`}</Text>
                {
                  category.isRequired && (
                    <Text size={14} color="red">*</Text>
                  )
                }
              </Space>

              <div style={{ marginTop: 10 }} />

              {
                category.isRequired && (
                  <Text size={12} style={{  }}>Sélectionnez l'une des options suivantes</Text>
                ) 
              }
              
              <div style={{ marginBottom: 10, marginTop: 10 }} />

              <Radio.Group
                value={getSelectedOptionForCategory(category)}
              >
                <Space direction="vertical">
                  {
                    category.selectableOptions.map((option) => (
                      <div style={{ display: 'flex', width: '100%' }}>
                        <Image src={option.image.original} width={50} style={{ marginRight: 10 }} />
                        
                        <Radio 
                          value={option.id} 
                          style={{ fontSize: 12, marginLeft: 10 }}
                          onChange={(e) => handleOnChooseOption(category)(option)}
                        >
                          {option.name.fr}
                        </Radio>

                        {
                          !option.is_required && (
                            <Text style={{ marginTop: 4, marginLeft: 'auto' }}>{option.price}€</Text>
                          )
                        }
                      </div>
                    ))
                  }
                </Space>
              </Radio.Group>
            </div>
          ))
        }
      </div>
      
      <div style={{ display: 'flex' }}>
        <Button type="primary" onClick={() => handleOnSubmitOption()}>Continuer</Button>
        <StyledButtonLink type="link" onClick={setEnv} style={{ color: '#53b297'}}>Réinitialiser</StyledButtonLink>
      </div>
    </StyledModal>
  )
}

const stateToProps = state => ({
  ui: state.ui
})

export default connect(stateToProps)(withTranslation()(OptionsModal));